// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
import { Modal, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
// @end dependencies

// @import components
import AlertComponent from 'app_components/commons/alert'
import DataTableComponent from 'app_components/commons/dataTable'
import moment from 'moment';
// @end components

// @import types
import { QualifiedTeacher } from 'app_types/admin/qualifiedTeacher/qualifiedTeacherTypes'
// @end types

// @import services
import QualifiedTeacherService from 'app_services/admin/qualifiedTeacher/qualifiedTeacherService'
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalQualifiedTeacher.scss'
// @end styles

interface IModalQualifiedTeacherProps {
  open: boolean
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  hideCloseButton?: boolean
  teacherId: string
  onClose?: (response?: {created?: boolean, response?: any})=>any
}

const ModalQualifiedTeacher: React.FC<IModalQualifiedTeacherProps> = (props) => {

  const { t } = useTranslation()
  const qualifiedTeacherService = new QualifiedTeacherService();

  const [listCoursesQualificated, updateListCoursesQualificated] = useState<QualifiedTeacher[]>([]);
  const [loadingListCoursesQualificated, updateLoadingListCoursesQualificated] = useState<boolean>(false);

  /**
   * @INFO Click en cerrar
   */
  const handleClickClose = () => {
    if(props.onClose){
      props.onClose()
    }
  }

  useEffect(() => {
    getCourseQualificatedByTeacher(props.teacherId);
  }, [])

  const getCourseQualificatedByTeacher = async (_id: string) => {
    updateLoadingListCoursesQualificated(true)
    updateListCoursesQualificated([])
    const teachersResponse: any = await qualifiedTeacherService.listQualifiedTeachers({
      teacher: _id,
      statuses: ['ACTIVO', 'active']
    })
    if (teachersResponse?.qualifiedTeachers) {
      let _qualifiedTeachers: any[] = teachersResponse.qualifiedTeachers;
      if (_qualifiedTeachers) {
        _qualifiedTeachers.sort((a,b) => a.courseCode - b.courseCode);
        updateListCoursesQualificated(_qualifiedTeachers);
      }
    }
    updateLoadingListCoursesQualificated(false)
  }

  return(
    <Modal
      className={`modal-qualified-teacher-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
      size='lg'
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal-qualified-teacher-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <div className="title">
            {t("modules.modal_qualified_teacher.title")}
          </div>
          {loadingListCoursesQualificated ? (
            <Spinner className='spinner-loading' animation='border' />
          ) : (
            <>
              {listCoursesQualificated && Array.isArray(listCoursesQualificated) && listCoursesQualificated.length > 0 ? (
                <>
                  <DataTableComponent
                    data={listCoursesQualificated}
                    headerKeys={[
                      `${t('modules.modal_qualified_teacher.headers.code')}`,
                      `${t('modules.modal_qualified_teacher.headers.name')}`,
                      `${t('modules.modal_qualified_teacher.headers.status')}`,
                      `${t('modules.modal_qualified_teacher.headers.date')}`
                    ]}
                    keys={['courseCode', 'courseName', 'status']}
                    detailsKey={[]}
                    onModal={null}
                    hideTooltip
                    rowButtons={(teacher: QualifiedTeacher) => (
                      <div>
                        {moment(teacher.evaluationDate).format('YYYY/MM/DD').includes('1969') ? '-' : moment.utc(teacher.evaluationDate).format('YYYY/MM/DD')}
                      </div>
                    )}
                  />
                </>
              ): (
                <AlertComponent
                  type='warning'
                  title={t('modules.modal_qualified_teacher.no_data')}
                />
              )}
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalQualifiedTeacher;
